import React from 'react';
import ModalSpinner from './ModalSpinner';

const Loader = () => <ModalSpinner show />;

export default Loader;
